import { esNavegadorMobile } from "../../../../utils/layout";
import { Container, ControlsContainer } from "../../../styled/MediaControls";
import CameraButton from "./buttons/CameraButton";
import ChatToggleButtonContainer from "./buttons/ChatToggleButtonContainer";
import LeaveRoomButton from "./buttons/LeaveRoomButton";
import MicButton from "./buttons/MicButton";
import SwitchToScreenSharingButton from "./buttons/SwitchToScreenSharingButton";

const MediaControlsContainer = ({
  room,
  selfShareCanvas,
  deberiaEstarEnSalaEspera,
  messages,
  selfViewRef,
  toggleChat,
  isChatOpen,
  unreadMessages,
  tieneViewportPocaAltura,
}) => {
  // Check if the browser is mobile
  const esMobile = esNavegadorMobile();

  return (
    <ControlsContainer>
      <Container>
        <MicButton room={room} />
        <CameraButton room={room} selfViewRef={selfViewRef} />
        {!esMobile && (
          <SwitchToScreenSharingButton
            room={room}
            selfShareCanvas={selfShareCanvas}
            deberiaEstarEnSalaEspera={deberiaEstarEnSalaEspera}
          />
        )}
        <LeaveRoomButton room={room} messages={messages} />
      </Container>
      {
        !deberiaEstarEnSalaEspera ? (
          <ChatToggleButtonContainer
            toggleChat={toggleChat}
            isChatOpen={isChatOpen}
            unreadMessages={unreadMessages}
            tieneViewportPocaAltura={tieneViewportPocaAltura}
          />
        ) : (
          <></>
        )}
    </ControlsContainer>
  )
}

export default MediaControlsContainer;
